module.exports = "<div class=\"btn-group\" data-toggle=\"buttons\">\n    <label\n    \tclass=\"btn {{btnVariant}} {{btnSize}} {{ item.disabled ? 'disabled' : '' }} {{ selection == item.value ? 'active' : '' }}\"\n    \tv-for=\"item in list\">\n      <input\n      \ttype=\"radio\"\n      \tname=\"options\"\n      \tvalue=\"{{item.value}}\"\n      \tautocomplete=\"off\"\n      \tv-model=\"selection\"\n        :disabled=\"item.disabled\"> {{item.text}}\n    </label>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/button-radio/button-radio.html
// module id = 13
// module chunks = 0